import { appOrigin } from "@/lib/absolute-url";
import { buildLocalizedPagePath } from "@/lib/localized-page-path";
import { curatedCrateOffersLink, type CuratedCrate } from "@garimpa/lib/curatedCrates";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

/** `CollectionPage` whose `ItemList` is the rendered crates, each pointing at its canonical offers URL. */
export function buildGarimposJsonLd(input: {
  locale: ViewerLocale;
  title: string;
  description: string;
  crates: readonly CuratedCrate[];
  crateName: (crate: CuratedCrate) => string;
}) {
  const url = `${appOrigin()}${buildLocalizedPagePath(input.locale, "garimpos")}`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "@id": `${url}#page`,
        url,
        name: input.title,
        description: input.description,
        inLanguage: input.locale,
        isPartOf: { "@id": `${appOrigin()}/#website` },
        mainEntity: {
          "@type": "ItemList",
          numberOfItems: input.crates.length,
          itemListElement: input.crates.map((crate, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: input.crateName(crate),
            url: curatedCrateOffersLink(crate),
          })),
        },
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [{ "@type": "ListItem", position: 1, name: input.title, item: url }],
      },
    ],
  };
}
